import { HeaderInfo, ResultState, ResultTabType } from './state'
import { OLD_QUERY_RESULTS, NEW_QUERY_RESULTS } from '@/data-dummy/data-dummy'
import { MAX_CHECKS_ALLOWED } from '@/config/constants'
import { ActionContext } from 'vuex'

import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

export const setResults = function (context: ActionContext<ResultState, object>, { checkId }: { checkId: string; }): void {
  if (checkId === 'CHKdee5197282f8730c37290f6c99a75c8099a75c34') {
    context.commit('setResult', NEW_QUERY_RESULTS)

    return
  }

  context.commit('setResult', OLD_QUERY_RESULTS)
}

export const setHeaderInfo = (context: ActionContext<ResultState, object>, headerInfo: HeaderInfo): void => {
  context.commit('setHeaderInfo', headerInfo)
}

export const updateChecksCounter = async (context: ActionContext<ResultState, object>) => {
  const user = firebase.auth().currentUser

  if (user === null) {
    return
  }

  const result = await firebase.firestore().doc(`users/${user.uid}`).get()

  const userDocument = result.data()

  if (userDocument === undefined) {
    if (!document.cookie.includes('retry')) {
      document.cookie = 'retry=true; SameSite=Lax'
      setTimeout(() => window.location.reload(), 400)
      return
    }

    throw new Error('User not found on firestore')
  }

  const { checksCreated } = userDocument

  context.commit('setChecksCounter', MAX_CHECKS_ALLOWED - checksCreated)
}

export const updateCheckType = async (context: ActionContext<ResultState, object>, checkType: string) => {
  context.commit('setCheckType', checkType)
}

export const updateResultTab = async (context: ActionContext<ResultState, object>, activeResultTab: number) => {
  const tabToResultType: Record<number, ResultTabType> = {
    0: 'score',
    1: 'detail'
  }

  context.commit('setResultTab', tabToResultType[activeResultTab])
}
